/* global axios */
import ApiClient from '../ApiClient';

class CaptainScenarios extends ApiClient {
  constructor() {
    super('captain/assistants', { accountScoped: true });
  }

  get({ assistantId, page = 1, searchKey } = {}) {
    return axios.get(`${this.url}/${assistantId}/scenarios`, {
      params: { page, searchKey },
    });
  }

  show({ assistantId, id }) {
    return axios.get(`${this.url}/${assistantId}/scenarios/${id}`);
  }

  create({ assistantId, ...data } = {}) {
    return axios.post(`${this.url}/${assistantId}/scenarios`, {
      scenario: data,
    });
  }

  update({ assistantId, id }, data = {}) {
    return axios.put(`${this.url}/${assistantId}/scenarios/${id}`, {
      scenario: data,
    });
  }

  delete({ assistantId, id }) {
    return axios.delete(`${this.url}/${assistantId}/scenarios/${id}`);
  }

  // Proposals live outside the Vuex store: it keeps a single flat list of records, so
  // loading them there would leak them into the assistant's real scenarios.
  getPending({ assistantId }) {
    return axios.get(`${this.url}/${assistantId}/scenarios`, {
      params: { status: 'pending' },
    });
  }

  generationPreview({ assistantId, ...filters }) {
    return axios.get(
      `${this.url}/${assistantId}/scenarios/generation_preview`,
      { params: filters }
    );
  }

  generate({ assistantId, ...filters }) {
    return axios.post(`${this.url}/${assistantId}/scenarios/generate`, filters);
  }

  cancelGeneration({ assistantId }) {
    return axios.post(`${this.url}/${assistantId}/scenarios/cancel_generation`);
  }

  approve({ assistantId, id }) {
    return axios.post(`${this.url}/${assistantId}/scenarios/${id}/approve`);
  }
}

export default new CaptainScenarios();
